export default "/img/payabill.png"